<template>
	<el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
		<el-descriptions title="用户信息">
			<el-descriptions-item v-for="(item, index) in fieldContrast" :key="index" :label="item.chfieldName">
				{{ form[item.enfieldName] || '--'}}
			</el-descriptions-item>
		</el-descriptions>
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="medium" type="primary" @click="dialogFormVisible = false">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		fieldContrast: {
			type: Array
		}
	},

	data() {
		return {
			id:'',
			dialogFormVisible: false,
			disabled: false,
			title:'查看详情',
			form: {},
			formLabelWidth: '120px'
		};
	},
	created() {},
	methods: {
		loadData() {
			this.id = this.$route.query.id;
			console.log('详情', this.fieldContrast);
			this.dialogFormVisible = true;
			
		}
	}
};
</script>

<style></style>
